<template>
    <component :is="layout" />
</template>

<script lang="ts">
import BlankLayout from './layouts/BlankLayout.vue';
import DefaultLayout from './layouts/DefaultLayout.vue';
import _ from 'lodash';
import { useAuthStore } from './stores/AuthStore';
import { PathDefinition } from './utils/PathDefinition';

export default {
    name: 'App',
    components: {
        BlankLayout,
        DefaultLayout
    },
    data() {
        return {
            layout: null,
            authStore: useAuthStore()
        };
    },
    watch: {
        $route(to) {
            if (to.meta.layout !== undefined) {
                this.layout = to.meta.layout;
            } else {
                this.layout = 'BlankLayout';
            }
        }
    },
    methods: {
        async checkSignedIn(): Promise<boolean> {
            return await this.authStore.isAuthenticated();
        }
    },
    async mounted() {
        const signedIn = await this.checkSignedIn();
        if (!signedIn) {
            await this.$router.push({ path: PathDefinition.signIn });
        }
    }
};
</script>
